import { useEffect, useState } from "react";

/** Below Tailwind's `lg`: the widths the step-by-step booking is for (1NOW-11155). */
export const PHONE_QUERY = "(max-width: 1023px)";
/** From `lg` up: the widths the Sixt-style booking pages are for (1NOW-11173). */
export const DESKTOP_QUERY = "(min-width: 1024px)";

const read = (query: string) =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(query).matches;

const useMatch = (query: string): boolean => {
  const [match, setMatch] = useState(() => read(query));
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener ? mq.addEventListener("change", on) : mq.addListener(on);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", on) : mq.removeListener(on);
    };
  }, [query]);
  return match;
};

/**
 * Is the page at a phone width? False where there is no matchMedia (tests,
 * old browsers), so a missing API leaves the desktop page exactly as it was.
 */
export const useIsPhone = (): boolean => useMatch(PHONE_QUERY);

/**
 * Is the page at a desktop width (1024px and up)? Also false where there is no
 * matchMedia: both answers are "no" there, and the page stays the old one.
 */
export const useIsDesktop = (): boolean => useMatch(DESKTOP_QUERY);
